import { Typography } from '@mui/material'
import clsx from 'clsx'
import React from 'react'
import {
    PatientFormBodySectionGetStateResult,
    PatientFormBodySectionProps,
    PatientFormBodySectionState,
} from './_props'
import useStyles from './_styles/PatientFormBodySectionStyles'

const PatientFormBodySection = ({
    label,
    notification,
    children,
    id,
    labelSideComponent,
    highlight,
}: PatientFormBodySectionProps) => {
    const classes = useStyles()

    const getStateClasses = (state: PatientFormBodySectionState | undefined, type: 'hightlight' | 'notification') => {
        let result: PatientFormBodySectionGetStateResult | undefined

        if (state === 'WARNING') {
            result = {
                highlight: clsx(
                    classes.PatientFormBodySectionHighlighted,
                    classes.PatientFormBodySectionHighlightedWarning
                ),
                notification: classes.PatientFormBodySectionTitleNotificationWarning,
            }
        }
        if (state === 'ERROR') {
            result = {
                highlight: clsx(
                    classes.PatientFormBodySectionHighlighted,
                    classes.PatientFormBodySectionHighlightedError
                ),
                notification: classes.PatientFormBodySectionTitleNotificationError,
            }
        }

        if (result && type === 'hightlight') {
            return result.highlight
        }
        if (result && type === 'notification') {
            return result.notification
        }

        return undefined
    }

    return (
        <div className={clsx(classes.PatientFormBodySection, getStateClasses(highlight, 'hightlight'))} id={id}>
            <div className={classes.PatientFormBodySectionContainer}>
                <div className={classes.PatientFormBodySectionTitleContainer}>
                    <Typography className={classes.PatientFormBodySectionTitle}>{label}</Typography>
                    {notification && (
                        <div
                            className={clsx(
                                classes.PatientFormBodySectionTitleNotification,
                                getStateClasses(notification, 'notification')
                            )}
                        />
                    )}
                    {labelSideComponent}
                </div>
                <div className={classes.PatientFormBodySectionContent}>{children}</div>
            </div>
        </div>
    )
}

export default PatientFormBodySection
